// Dependency-free so lib/swapLifecycle (a leaf imported by the deposit/transfer execution
// paths and their headless tests) can key its phase table on the enum without pulling the
// API client graph behind resolveSwapPhase.
export var SwapPhase;
(function (SwapPhase) {
    SwapPhase["AwaitingUserDeposit"] = "awaiting_user_deposit";
    SwapPhase["InputPending"] = "input_pending";
    SwapPhase["OutputPending"] = "output_pending";
    SwapPhase["SettlingOutput"] = "settling_output";
    SwapPhase["Completed"] = "completed";
    SwapPhase["Failed"] = "failed";
    SwapPhase["Expired"] = "expired";
    SwapPhase["PendingRefund"] = "pending_refund";
    SwapPhase["Refunded"] = "refunded";
})(SwapPhase || (SwapPhase = {}));
export const TERMINAL_PHASES = new Set([
    SwapPhase.Completed,
    SwapPhase.Failed,
    SwapPhase.Expired,
    SwapPhase.Refunded,
]);
